import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { MasterLayoutTemplate } from 'themes/layouts';
import { setCurrentView } from '../utils';
import { defaultTemplate } from 'core/hoc';
import { useStores } from 'core/stores/StoreContext';

class MasterStore {
    constructor(rootStore) {
        this.rootStore = rootStore;
    }
}

const MasterLayout = observer((props) => {
    const rootStore = useStores();
    return (
        <MasterLayoutTemplate
            {...props}
            initialized={rootStore.appStore.initialized}
            language={rootStore.localizationStore.language}
        />
    );
});

MasterLayout.propTypes = {
    render: PropTypes.func
};

export default defaultTemplate(
    setCurrentView(rootStore => new MasterStore(rootStore), 'masterView')(MasterLayout)
);
